module.exports = __webpack_public_path__ + "static/media/1day@2x.ae4ece12.png";